import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getGoogleMapsSignUrl } from '../api-ts';

export function useGetGoogleMapsUrl(url: string) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getGoogleMapsUrl', url],
    queryFn: () => dispatch(getGoogleMapsSignUrl(url)),
  });
}
